 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "inputs/js/" + ({"addTask":"addTask","allocation":"allocation","analysis":"analysis","analysis_arch":"analysis_arch","analysis_arima":"analysis_arima","analysis_autocorre":"analysis_autocorre","analysis_bivar":"analysis_bivar","analysis_curvefit":"analysis_curvefit","analysis_engleGranger":"analysis_engleGranger","analysis_expsmooth":"analysis_expsmooth","analysis_garch":"analysis_garch","analysis_grangerCheck":"analysis_grangerCheck","analysis_hp":"analysis_hp","analysis_johansen":"analysis_johansen","analysis_leastsquares":"analysis_leastsquares","analysis_lr":"analysis_lr","analysis_partial":"analysis_partial","analysis_unitCheck":"analysis_unitCheck","analysis_varModel":"analysis_varModel","article~articles~cube~reback":"article~articles~cube~reback","article~articles":"article~articles","article":"article","articles":"articles","cube":"cube","reback":"reback","cloud":"cloud","cloud_index~data":"cloud_index~data","cloud_index":"cloud_index","data":"data","collections":"collections","datas":"datas","dictionary":"dictionary","history":"history","infoCenter":"infoCenter","itemAllocation":"itemAllocation","login":"login","platform":"platform","register":"register","resetPwd":"resetPwd","series":"series","source":"source","tags":"tags","teamAddTask":"teamAddTask","teamAllocation":"teamAllocation","user":"user"}[chunkId]||chunkId) + "." + {"addTask":"630fced5","allocation":"674ea76d","analysis":"3ec87059","analysis_arch":"2126b115","analysis_arima":"d24aa763","analysis_autocorre":"8243b05e","analysis_bivar":"a9640e67","analysis_curvefit":"fff5610b","analysis_engleGranger":"3fce9089","analysis_expsmooth":"6a247225","analysis_garch":"3807405e","analysis_grangerCheck":"74705b51","analysis_hp":"6a6a2ddd","analysis_johansen":"d18b8850","analysis_leastsquares":"08cd237a","analysis_lr":"abca956f","analysis_partial":"8a469460","analysis_unitCheck":"0554ffbb","analysis_varModel":"e887450c","article~articles~cube~reback":"f57a4130","article~articles":"92249ec0","article":"da1e9ae7","articles":"62f54c77","cube":"5c6a9f7e","reback":"2214c2ac","cloud":"68bbd8c1","cloud_index~data":"4f085f27","cloud_index":"5a02d419","data":"199e3e01","collections":"1fb93f18","datas":"a9640d6d","dictionary":"3996e693","history":"027c0c90","infoCenter":"1e18ef52","itemAllocation":"8bc4c3d8","login":"d900a92f","platform":"daaddf94","register":"8459152e","resetPwd":"5f9fd3ab","series":"10f8fe85","source":"a689061b","tags":"ba005dad","teamAddTask":"f83ca4a7","teamAllocation":"06bdef0a","user":"f0213355"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"addTask":1,"allocation":1,"analysis":1,"analysis_arch":1,"analysis_arima":1,"analysis_autocorre":1,"analysis_bivar":1,"analysis_curvefit":1,"analysis_engleGranger":1,"analysis_expsmooth":1,"analysis_garch":1,"analysis_grangerCheck":1,"analysis_hp":1,"analysis_johansen":1,"analysis_leastsquares":1,"analysis_lr":1,"analysis_partial":1,"analysis_unitCheck":1,"analysis_varModel":1,"article~articles~cube~reback":1,"article":1,"articles":1,"cube":1,"reback":1,"cloud":1,"cloud_index~data":1,"cloud_index":1,"data":1,"collections":1,"datas":1,"dictionary":1,"history":1,"infoCenter":1,"itemAllocation":1,"login":1,"platform":1,"register":1,"resetPwd":1,"series":1,"source":1,"tags":1,"teamAddTask":1,"teamAllocation":1,"user":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "inputs/css/" + ({"addTask":"addTask","allocation":"allocation","analysis":"analysis","analysis_arch":"analysis_arch","analysis_arima":"analysis_arima","analysis_autocorre":"analysis_autocorre","analysis_bivar":"analysis_bivar","analysis_curvefit":"analysis_curvefit","analysis_engleGranger":"analysis_engleGranger","analysis_expsmooth":"analysis_expsmooth","analysis_garch":"analysis_garch","analysis_grangerCheck":"analysis_grangerCheck","analysis_hp":"analysis_hp","analysis_johansen":"analysis_johansen","analysis_leastsquares":"analysis_leastsquares","analysis_lr":"analysis_lr","analysis_partial":"analysis_partial","analysis_unitCheck":"analysis_unitCheck","analysis_varModel":"analysis_varModel","article~articles~cube~reback":"article~articles~cube~reback","article~articles":"article~articles","article":"article","articles":"articles","cube":"cube","reback":"reback","cloud":"cloud","cloud_index~data":"cloud_index~data","cloud_index":"cloud_index","data":"data","collections":"collections","datas":"datas","dictionary":"dictionary","history":"history","infoCenter":"infoCenter","itemAllocation":"itemAllocation","login":"login","platform":"platform","register":"register","resetPwd":"resetPwd","series":"series","source":"source","tags":"tags","teamAddTask":"teamAddTask","teamAllocation":"teamAllocation","user":"user"}[chunkId]||chunkId) + "." + {"addTask":"0941c304","allocation":"cd8e341e","analysis":"dd0eeeb5","analysis_arch":"89711ff0","analysis_arima":"00463d25","analysis_autocorre":"f8bd6045","analysis_bivar":"89711ff0","analysis_curvefit":"f8bd6045","analysis_engleGranger":"89711ff0","analysis_expsmooth":"00463d25","analysis_garch":"89711ff0","analysis_grangerCheck":"89711ff0","analysis_hp":"f8bd6045","analysis_johansen":"89711ff0","analysis_leastsquares":"89711ff0","analysis_lr":"f8bd6045","analysis_partial":"89711ff0","analysis_unitCheck":"89711ff0","analysis_varModel":"89711ff0","article~articles~cube~reback":"59e38391","article~articles":"31d6cfe0","article":"86c42cea","articles":"7fd12722","cube":"50d308f4","reback":"5f533cac","cloud":"1ff10df5","cloud_index~data":"b8aa796f","cloud_index":"675dd1ae","data":"9cb82291","collections":"cd313931","datas":"95081b89","dictionary":"84869ef6","history":"f06a3ca2","infoCenter":"a2338b0b","itemAllocation":"5d40550c","login":"61a3d18e","platform":"0444f5d1","register":"918637c6","resetPwd":"42b1615a","series":"77a0958c","source":"d0310c1c","tags":"11666a42","teamAddTask":"446f2040","teamAllocation":"dc448282","user":"2b06f51c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
